import { createMutationHook } from '~/shared/providers/api';

export const useAcceptUserInvitationMutation = createMutationHook(
  'authentication.acceptUserInvitation',
  (params: { token: string; password: string }) => ({
    authenticationAcceptUserInvitation: {
      __args: {
        token: params.token,
        password: params.password,
      },
      __typename: true,
      on_UserInvitationAcceptedResult: {
        userId: true,
        email: true,
        success: true,
      },
      on_InvalidUserInvitationError: {
        reason: true,
      },
    },
  }),
);
